import { render, staticRenderFns } from "./TournamentPublishing.vue?vue&type=template&id=4ce7a5a3&scoped=true"
import script from "./TournamentPublishing.vue?vue&type=script&lang=js"
export * from "./TournamentPublishing.vue?vue&type=script&lang=js"
import style0 from "./TournamentPublishing.vue?vue&type=style&index=0&id=4ce7a5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7a5a3",
  null
  
)

export default component.exports